export const normalizeFontMedias = (medias) => (
  Array.isArray(medias)
    ? medias.filter((media) => media?.name)
    : []
);

export const getFontOptions = (medias, selectedFontFamily) => {
  const options = normalizeFontMedias(medias);

  if (!selectedFontFamily || options.some((option) => option.name === selectedFontFamily)) {
    return options;
  }

  return [
    {
      id: '__selected-font',
      name: selectedFontFamily,
      type: 'font',
      url: '',
    },
    ...options,
  ];
};

export const loadFontStylesheets = (medias) => {
  if (typeof document === 'undefined') {
    return;
  }

  normalizeFontMedias(medias)
    .filter((media) => media.url)
    .forEach((media) => {
      const isAlreadyLoaded = Array.from(
        document.head.querySelectorAll('link[rel="stylesheet"]')
      ).some((link) => link.getAttribute('href') === media.url);

      if (isAlreadyLoaded) {
        return;
      }

      const link = document.createElement('link');
      link.href = media.url;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    });
};
